/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, CanBeSignals, getProp, destructProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {$Popup} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Popup';
import {$HorizontalSeparator} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/HorizontalSeparator';
import {$AutoplayStartButton} from './$AutoplayStartButton';
import {$AutoplayRoundsSelector} from './$AutoplayRoundsSelector';
import {$AutoplayOptionsSelector} from './$AutoplayOptionsSelector';
import {$AutoplayLimitsSelector} from './$AutoplayLimitsSelector';
import {$AutoplaySettingsProps, getResponsiveConfig} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/UIAutoplayOptions/components/$AutoplaySettings';

export type $AutoplaySettingsBaseProps = $AutoplaySettingsProps & CanBeSignals<{
    faderAlpha?: number;
    roundsCount: number;
    responsiveConf: ReturnType<typeof getResponsiveConfig>;
}>;

export const $AutoplaySettingsBase: FC<$AutoplaySettingsBaseProps> = (props) => {
    const {popup, limitsSelector, limitsSeparator, optionsSelector, roundsSelector, autoplayButton} = destructProp(props.responsiveConf,
        ['popup', 'limitsSelector', 'limitsSeparator', 'optionsSelector', 'roundsSelector', 'autoplayButton']);

    return <$Popup
        show={props.showOptionsPopup}
        headerId='autoplaySettings'
        headerMaxWidth={900}
        onClose={props.onClose}
        responsiveConfig={popup.value}
        faderAlpha={props.faderAlpha}
    >
        <$AutoplayLimitsSelector
            responsive={limitsSelector}
            scale={[0.74, 0.74]}
            hidden={props.disabledLimits}
            singleWin={{action: props.onSingleWin, value: props.singleWin}}
            winLimit={{action: props.onWinLimit, value: props.winLimit}}
            lossLimit={{action: props.onLossLimit, value: props.lossLimit}}
        />

        <$HorizontalSeparator
            visible={!getProp(props.disabledLimits)}
            lineWidth={800}
            responsive={limitsSeparator}
        />

        <$AutoplayOptionsSelector
            responsive={optionsSelector}
            quickSpin={{value: props.quickSpin, action: props.onQuickSpin}}
            turboSpin={{value: props.turboSpin, action: props.onTurboSpin}}
            untilBonus={{value: props.untilBonus, action: props.onUntilBonus}}
        />

        <$AutoplayRoundsSelector
            responsive={roundsSelector}
            roundsCount={props.roundsCount}
            options={getProp(props.autoplayValues)}
            action={() => getProp(props.onUpdateValue)(getProp(props.roundsCount))}
        />

        <$AutoplayStartButton
            responsive={autoplayButton}
            action={() => getProp(props.onStartAutoplay)(getProp(props.roundsCount))}
        />
    </$Popup>;
};